import React from "react";
import styled from "styled-components";
import { IconPromoCodeFilled } from "src/icons";
import { DarkGrey, Green } from "src/styles/color";
import { hexToRgba } from "src/common/color";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import font from "src/styles/font";

const S = {};

S.PromoCodeItem = styled.div`
  flex-shrink: 0;
  width: 420px;
  max-width: 100%;
  border-radius: 16px;
  margin-bottom: 16px;
  overflow: hidden;
  border: 1px solid ${Green};
  background-color: ${hexToRgba(Green, 0.1)};
  margin: 0 auto;
`;

S.PromoCodeContainer = styled.div`
  display: flex;
  align-items: center;
  height: 120px;
`;

S.DiscountIcon = styled.div`
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* border-radius: 16px 0 0 16px; */
  /* background: #219653; */
  gap: 8px;
  /* width: 30%; */
  height: 100%;
  border-right: 1px dashed ${Green};
  /* flex-shrink: 0; */
  flex: 2;
`;

S.Text = styled.div`
  font-size: ${({ fontSize }) => fontSize};
  font-weight: ${({ fontWeight }) => fontWeight};
  color: ${({ color }) => color};
  text-align: ${({ textAlign }) => textAlign};
`;

S.DiscountDetail = styled.div`
  padding: 12px 12px 12px 16px;
  /* border-radius: 0 16px 16px 0; */
  /* background: rgba(33, 150, 83, 0.1); */
  /* height: 120px; */
  gap: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* width: 60%; */
  /* flex-shrink: 0; */
  height: 100%;
  flex: 4;
  min-width: 0;
`;

S.PromoCodeName = styled.div`
  color: ${Green};
  font-size: ${font.size.md};
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

S.PromoCodeTitle = styled.div`
  color: ${DarkGrey};
  font-size: ${font.size.md};
  font-weight: 400;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
`;

S.PromoCodeExpire = styled.div`
  color: ${DarkGrey};
  font-size: ${font.size.md};
  font-weight: 400;
`;

const PromoCodeItem = ({ promoCode, promoName, promoTitle, promoExpire }) => {
  return (
    <S.PromoCodeItem>
      <S.PromoCodeContainer>
        <S.DiscountIcon>
          <IconPromoCodeFilled fill={Green} width={30} height={24} />
          <S.Text
            fontSize={font.size.xs}
            fontWeight="400"
            color={Green}
            textAlign="center"
          >
            {promoCode}
          </S.Text>
        </S.DiscountIcon>

        <S.DiscountDetail>
          <S.PromoCodeName title={promoName}>{promoName}</S.PromoCodeName>
          <S.PromoCodeTitle title={promoTitle}>{promoTitle}</S.PromoCodeTitle>
          <S.PromoCodeExpire>
            หมดอายุ{" "}
            {new Date(promoExpire).toLocaleDateString("th-TH", {
              year: "numeric",
              month: "short",
              day: "numeric",
            })}
          </S.PromoCodeExpire>
        </S.DiscountDetail>

        <div
          style={{
            alignSelf: "flex-start",
            flex: 1,
            display: "flex",
            justifyContent: "center",
            padding: "12px 0",
          }}
        >
          <CheckCircleIcon sx={{ color: Green }} />
        </div>
      </S.PromoCodeContainer>
    </S.PromoCodeItem>
  );
};

export default PromoCodeItem;
